import React, { Component } from 'react'

const Location = () => {
    return <div style={{ color: 'red' }}>Location</div>
}

export default Location
